/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { ApiResponse, AxiosApiResponse } from '@common/types/api';

export class Locale {
  bcp47: string;
  countryId: string;
  microsoftLanguageCode: string;
  description: string;
  defaultCurrencyId?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  nativeDescription?: string;

  constructor(bcp47: string, countryId: string, microsoftLanguageCode: string, description: string, defaultCurrencyId: string, nativeDescription: string) {
    this.bcp47 = bcp47;
    this.countryId = countryId;
    this.microsoftLanguageCode = microsoftLanguageCode;
    this.description = description;
    this.defaultCurrencyId = defaultCurrencyId;
    this.nativeDescription = nativeDescription;
  }

  static list(): ApiResponse<Locale[]> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/locales`, {
          params: {
            sequence_id: 1,
          },
        })
        .then((res) => ({ ...res, data: undefined, ...res.data }));
    }
    throw new Error();
  }

  static get(id: string): ApiResponse<Locale> {
    return axiosInstance.get(`/api/v1/locales/${id}`).then((res) => ({ ...res.data }));
  }

  static delete(id: string): ApiResponse<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/locales/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: string): ApiResponse<Record<string, unknown>> {
    return axiosInstance.post(`/api/v1/locales/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(updatedLocale: { name: string; companyId: number; logo: string }, id: string): ApiResponse<Record<string, unknown>> {
    return axiosInstance.patch(`/api/v1/locales/${id}`, { payload: updatedLocale }).then((res) => ({ ...res.data }));
  }

  static getAddTemplate(): AxiosApiResponse<Record<string, unknown>> {
    return axiosInstance.get(`/api/v1/templates/locales/add`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  add(): Promise<Record<string, unknown>> {
    return axiosInstance
      .post(`/api/v1/locales`, {
        payload: {
          bcp47: this.bcp47,
          countryId: this.countryId,
          microsoftLanguageCode: this.microsoftLanguageCode,
          description: this.description,
          defaultCurrency: this.defaultCurrencyId,
        },
      })
      .then((res) => ({ ...res.data }));
  }
}
